import SashiDo from 'lib/SashiDo';
import { ActionTypes } from 'lib/stores/JobsStore';
import CategoryList from 'components/CategoryList/CategoryList.react';
import DashboardView from 'dashboard/DashboardView.react';
import ParseApp from 'lib/ParseApp';
import React from 'react';
import history from 'dashboard/history';
import PropTypes from 'prop-types';
import subscribeTo from 'lib/subscribeTo';
import FlowView from 'components/FlowView/FlowView.react';
import styles from 'dashboard/Data/Jobs/Jobs.scss';
import Toolbar from 'components/Toolbar/Toolbar.react';
import ReleaseInfo from 'components/ReleaseInfo/ReleaseInfo';

import settingsStyles from 'dashboard/Settings/Settings.scss';
import Button from 'components/Button/Button.react';
import DateTimeInput from 'components/DateTimeInput/DateTimeInput.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Field from 'components/Field/Field.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import IntervalInput from 'components/IntervalInput/IntervalInput.react';
import Label from 'components/Label/Label.react';
import pluralize from 'lib/pluralize';
import TextInput from 'components/TextInput/TextInput.react';
import Toggle from 'components/Toggle/Toggle.react';
import { hoursFrom, dateStringUTC } from 'lib/DateUtils';

// class JobEdit extends React.Component {
@subscribeTo('Jobs', 'jobs')
class JobEdit extends DashboardView {
  constructor(props, context) {
    super(props, context);
    this.section = 'Core';
    this.subsection = 'Jobs';
  }

  renderSidebar() {
    let current = this.props.params.section || '';
    return (
      <CategoryList current={current} linkPrefix={'jobs/'} categories={[
        { name: 'Scheduled Jobs', id: 'scheduled' },
        { name: 'Job Status', id: 'status' }
      ]} />
    );
  }

  onCloseClick() {
    history.push(`/products/apps/${this.context.currentApp.slug}/jobs/scheduled`);
  }


  submitForm(changes) {
    // ***************************
    // Hardcode this for now
    // changes.repeatType        = 'on an interval'
    changes.repeatStartHour = '00'
    changes.repeatStartMinute = '00'
    // Hardcode this for now
    // ***************************

    let schedule = {
      params: changes.parameter || '{}',
      daysOfWeek: [1, 1, 1, 1, 1, 1, 1]
    };
    if (changes.description) {
      schedule.description = changes.description;
    }
    if (changes.job) {
      schedule.jobName = changes.job;
    }
    if (!changes.immediate && changes.runAt) {
      schedule.startAfter = changes.runAt.toISOString();
    }
    if (changes.repeat) {
      let hour = changes.repeatStartHour;
      if (hour.length < 2) {
        hour = '0' + hour;
      }
      schedule.timeOfDay = `${hour}:${changes.repeatStartMinute}:00.000Z`;
      let interval = 0;
      if (changes.repeatType === 'daily') {
        interval = 1440;
      } else {
        interval = changes.intervalCount * (changes.intervalUnit === 'hour' ? 60 : 1);
      }
      schedule.repeatMinutes = interval;
    }

    // let promise = this.context.currentApp.scheduleJob(schedule, this.props.params.jobId)

    let promise = this.props.params.jobId ?
      this.props.jobs.dispatch(ActionTypes.EDIT, { jobId: this.props.params.jobId, schedule }) :
      this.props.jobs.dispatch(ActionTypes.CREATE, { schedule });
    promise.then(() => {
      SashiDo.activityTrack({
        type: 'create_job',
        data: {
          message: `Successfully created Job (${changes.job}) for application ${this.context.currentApp.name}`,
        },
      });
      history.push(this.context.generatePath('jobs/scheduled'))
    });
    return promise;
  }

  componentWillMount() {
    this.props.jobs.dispatch(ActionTypes.FETCH, { jobId: this.props.params.jobId });
  }

  initialChanges() {
    if (this.initialFields.job) {
      let changes = {};
      if (!this.initialFields.repeatType) {
        changes.repeatType = 'daily';
      }
      if (!this.initialFields.repeatStartHour) {
        changes.repeatStartHour = '12';
      }
      if (!this.initialFields.repeatStartMinute) {
        changes.repeatStartHour = '00';
      }
      if (!this.initialFields.intervalCount) {
        changes.intervalCount = 15;
      }
      if (!this.initialFields.intervalUnit) {
        changes.intervalUnit = 'minute';
      }
      return changes;
    }
    return {
      description: '',
      job: '',
      parameter: '',
      immediate: true,
      runAt: hoursFrom(new Date(), 1),
      repeat: false,
      repeatType: 'daily',
      repeatStartHour: '12',
      repeatStartMinute: '00',
      intervalCount: 15,
      intervalUnit: 'minute'
    };
  }

  renderRepeatFields(fields, setField) {
    if (!fields.repeat) {
      return null;
    }
    let rows = []

    rows.push(
      <Field
        key='repeatType' className='oneliner'
        label={<Label className='oneliner' text='Should it repeat daily?' />}
        input={
          <Toggle
            type={Toggle.Types.TWO_WAY}
            className='oneliner'
            value={fields.repeatType}
            optionLeft='on an interval'
            optionRight='daily'
            onChange={setField.bind(null, 'repeatType')} />
        }
      />
    );
    if (fields.repeatType === 'daily') {
      rows.push(
        //   <Field
        //     key='runAt'
        //     labelWidth={60}
        //     label={<Label text='When should it run each day?' />}
        //     input={
        //       <TimeInput
        //         hours={fields.repeatStartHour}
        //         minutes={fields.repeatStartMinute}
        //         onChange={(hour, minute) => {
        //           setField('repeatStartHour', hour);
        //           setField('repeatStartMinute', minute);
        //         }} />
        //     } />
        //  <div className={settingsStyles.oneliner}>
        //    <Label key='repeat-description' className='oneliner' text={`This job will repeat on a daily basis starting at ${dateStringUTC(fields.runAt).split(' at ')[1]}`} />
        //  </div>
      );
    } else {
      rows.push(
        <Field
          key='interval'
          labelWidth={60}
          label={<Label text='Repeat on what interval?' />}
          input={<IntervalInput
            count={fields.intervalCount}
            unit={fields.intervalUnit}
            onChange={(count, unit) => {
              setField('intervalCount', count);
              setField('intervalUnit', unit);
            }} />} />
      );
      // rows.push(
      //   <Field
      //     key='repeatStart'
      //     labelWidth={60}
      //     label={<Label text='Starting at what time each day?' />}
      //     input={
      //       <TimeInput
      //         hours={fields.repeatStartHour}
      //         minutes={fields.repeatStartMinute}
      //         onChange={(hour, minute) => {
      //           setField('repeatStartHour', hour);
      //           setField('repeatStartMinute', minute);
      //         }} />
      //     } />
      // )
    }
    return rows;
  }

  renderForm({ fields, changes, setField, resetFields }) {
    let jobs = this.props.availableJobs || [];
    if (this.initialFields.job) {
      jobs = [this.initialFields.job].concat(jobs);
    }

    return (
      <div className={[styles.settings_page, 'ShowFooter'].join(' ')}>
        <Toolbar section='Jobs' subsection='Schedule a Job' details={ReleaseInfo({ app: this.context.currentApp })}>
          <Button value='Go Back' onClick={this.onCloseClick.bind(this)} />
        </Toolbar>

        <div className={styles.holder}>

          {this.props.params.jobId ? null : (
            <Fieldset>
              <div>
                {this.props.jobsInUse && this.props.jobsInUse.length
                  ? <Label key='repeat-description' className='info' text={`This is an additional Cloud Job to app "${this.context.currentApp.name}". It costs $10/mo and will be billed at the end of your current billing cycle.`} />
                  : <Label key='repeat-description' className='info' text='Your first Cloud Job for this app is absolutely free. Every additional Cloud Job will be charged $10 per month.' />
                }
              </div>
            </Fieldset>
          )}

          <Fieldset
            legend='Pick a Job'
            description='Choose a job from your cloud code, and specify the parameters to run it with'>
            <div className={settingsStyles.settingsBox}>
              <Field
                label={<Label text='Description' description='Give this schedule a name that describes what it does' />}
                input={<TextInput
                  placeholder={'Pick a good name\u2026'}
                  value={fields.description}
                  onChange={setField.bind(null, 'description')} />
                } />
              <Field
                label={<Label text='Cloud job' description='Pick which cloud code job to run' />}
                input={
                  <ChromeDropdown
                    value={fields.job}
                    options={jobs}
                    onChange={setField.bind(null, 'job')} />
                } />
              <Field
                label={<Label text='Parameters' description='Specify an optional JSON object to pass to the job' />}
                input={<TextInput
                  monospace={true}
                  multiline={true}
                  height={120}
                  placeholder={'{\n  \u2026\n}'}
                  value={fields.parameter}
                  onChange={setField.bind(null, 'parameter')} />
                } />
            </div>
          </Fieldset>

          <Fieldset
            legend='Schedule a time'
            description='Choose when this job runs and how often it repeats'>
            <div className={styles.settingsBox}>
              <Field
                className='oneliner'
                label={<Label text='Start immediately?' className='oneliner' />}
                input={<Toggle value={fields.immediate} onChange={setField.bind(null, 'immediate')} />}
              />
              {fields.immediate ? null : <Field
                label={<Label text='When should it start?' />}
                input={
                  <DateTimeInput
                    // disabled={!!this.initialFields.job}
                    fixed={true}
                    value={fields.runAt}
                    onChange={setField.bind(null, 'runAt')} />
                } />
              }


              <div className={styles.hr}></div>

              {/*this.initialFields.job ? null :*/}
              <Field
                className='oneliner'
                label={<Label text='Should it repeat?' className='oneliner' description='You can schedule a job to run once every day, or on an interval' />}
                input={<Toggle value={fields.repeat} onChange={setField.bind(null, 'repeat')} />} />
              {/**/}
              {this.renderRepeatFields(fields, setField)}
            </div>
          </Fieldset>
        </div>
      </div>
    );
  }

  renderContent() {
    let initialFields

    if (this.props.params.jobId) {
      if (this.props.jobs.data.get('jobs') && this.props.jobs.data.get('jobs').size) {
        let data = this.props.jobs.data.get('jobs').filter((obj) => obj.objectId === this.props.params.jobId).first();
        // let data = this.props.jobs.data.get('jobs')[0];
        if (data) {
          initialFields = {
            description: data.description,
            job: data.jobName,
            parameter: data.params
          };
          if (data.repeatMinutes) {
            initialFields.repeat = true;
            if (data.repeatMinutes === 1440) {
              initialFields.repeatType = 'daily';
            } else {
              initialFields.repeatType = 'on an interval';
              if (data.repeatMinutes > 60) {
                initialFields.intervalCount = (data.repeatMinutes / 60) | 0;
                initialFields.intervalUnit = 'hour';
              } else {
                initialFields.intervalCount = data.repeatMinutes;
                initialFields.intervalUnit = 'minute';
              }
            }
          }
          if (data.startAfter) {
            initialFields.runAt = new Date(data.startAfter);
          }
          if (data.timeOfDay) {
            let split = data.timeOfDay.split(':');
            initialFields.repeatStartHour = split[0] || '12';
            if (split[0][0] === '0') {
              initialFields.repeatStartHour = split[0].substr(1);
            }
            initialFields.repeatStartMinute = split[1] || '00';
          } else {
            initialFields.repeatStartHour = '12';
            initialFields.repeatStartMinute = '00';
          }
        }
      }
      else {
        return null;
      }
    }
    else {
      initialFields = {}

      if (this.props.availableJobs && !this.props.availableJobs.length) {
        history.push(`/products/apps/${this.context.currentApp.slug}/jobs`);
      }
    }

    this.initialFields = initialFields

    return <FlowView
      initialChanges={this.initialChanges()}
      initialFields={this.initialFields}
      renderForm={this.renderForm.bind(this)}
      showFooter={changes => changes.job !== ''}
      submitText='Schedule'
      onSubmit={({ fields }) => this.submitForm(fields)}
      inProgressText='Scheduling\u2026'
      validate={({ changes, fields }) => {
        //Don't even display the footer if they haven't selected a name or function.
        if (!fields.job.length && !fields.description.length) {
          return '';
        }
        let errorMessages = [];
        if (!fields.description.length) {
          errorMessages.push('A description is required.');
        }
        if (!fields.job.length) {
          errorMessages.push('Pick a cloud code job to run.');
        }
        //Allow them to submit no params
        if (fields.parameter !== '') {
          try {
            JSON.parse(fields.parameter);
          } catch (e) {
            errorMessages.push('Parameters must be valid JSON.');
          }
        }
        return errorMessages.join(' ');
      }}
      footerContents={({ fields, changes }) => {
        let pieces = [];
        pieces.push(<strong key="a1">{fields.job}&nbsp;</strong>, 'will run ');
        if (fields.immediate) {
          pieces.push(<strong key="a2">&nbsp;immediately</strong>, '.')
        } else {
          pieces.push('on', <strong key="a3">&nbsp;{dateStringUTC(fields.runAt)}&nbsp;</strong>, '.');
        }
        if (fields.repeat) {
          pieces.push(' It will repeat ');
          if (fields.repeatType === 'daily') {
            pieces.push(
              <strong key="a4">&nbsp;every day&nbsp;</strong>,
              ' at ',
              <strong>&nbsp;{dateStringUTC(fields.runAt).split(' at ')[1]}&nbsp;</strong>,
            );
            if (dateStringUTC(fields.runAt)) {
              pieces.push(
                <strong>&nbsp;{dateStringUTC(fields.runAt).split(' at ')[1]}&nbsp;</strong>,
              );
            }
          } else {
            pieces.push(
              <strong key="a5">&nbsp;{'every ' + pluralize(fields.intervalCount, fields.intervalUnit)}&nbsp;</strong>,
              ' after ',
            );

            if (dateStringUTC(fields.runAt)) {
              pieces.push(
                <strong>&nbsp;{dateStringUTC(fields.runAt).split(' at ')[1]}&nbsp;</strong>,
              );
            }
          }
        }
        return pieces;
      }}
    />;
  }
}

JobEdit.original.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
  generatePath: PropTypes.func,
};

export default JobEdit;
